import {requestContext} from '../../../../common/requestContext';
import {twMerge} from '../../../../common/twMerge';
import {SectionType} from '../../../../graphql/generated/types';
import {useGetParentSection} from '../../../../pagewebLayout/useGetParentSection';
import {CommonGroupProps} from '../../type';

export function DisplayAd({group, children}: CommonGroupProps) {
  const {isMobile} = requestContext.requestInfo.display;
  const parentSection = useGetParentSection(group.id);
  // PC DA 영역 미지원
  if (!isMobile) {
    return null;
  }

  return (
    <div
      className={twMerge(parentSection.type === SectionType.Top && 'mt-4pxr')}
    >
      {children}
    </div>
  );
}
